/* ================================================================
   AISTROWISE — Horóscopo diario (deferred, no libraries)

   - Generates the decorative starfield (position:absolute, no CLS).
   - Hoy / Mañana toggle driven by the VISITOR's local calendar date
     (no geolocation); maps to one of the server-rendered date groups,
     falling back to the nearest available date if one is missing.
   - Re-renders the date line in the visitor's es-ES locale.
   - Boletín spam gates: honeypot + 3s time-gate (block submit only).

   Analytics events ride on data-aw-event / data-awp-* and are handled
   globally by aw-analytics.js — nothing to fire here.
   Loaded ONLY by sections/aw-horoscopo-diario.liquid.
   ================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-aw-hd]');
  if (!root) return;

  /* ── starfield ─────────────────────────────────────────────── */
  var starBox = root.querySelector('[data-aw-hd-stars]');
  if (starBox && !starBox.childElementCount) {
    var n = window.matchMedia('(min-width: 750px)').matches ? 90 : 46;
    var html = '';
    for (var i = 0; i < n; i++) {
      var sz = Math.random() < 0.18 ? 2 : 1;
      html += '<i style="left:' + (Math.random() * 100).toFixed(2) +
        '%;top:' + (Math.random() * 100).toFixed(2) +
        '%;width:' + sz + 'px;height:' + sz + 'px;--o:' + (0.25 + Math.random() * 0.6).toFixed(2) +
        ';animation-delay:-' + (Math.random() * 4).toFixed(2) + 's"></i>';
    }
    starBox.innerHTML = html;
  }

  /* ── date helpers (local calendar, no tz math beyond the browser) ── */
  function ymd(d) { return d.toLocaleDateString('en-CA'); } // 'YYYY-MM-DD'
  function parse(s) { var p = s.split('-'); return new Date(+p[0], (+p[1]) - 1, +p[2]); }
  function addDays(s, k) { var d = parse(s); d.setDate(d.getDate() + k); return ymd(d); }
  function diffDays(a, b) { return Math.round((parse(a) - parse(b)) / 86400000); }
  function fmt(s) {
    try {
      return parse(s).toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return ''; }
  }

  var heroDays = Array.prototype.slice.call(root.querySelectorAll('[data-aw-hd-day-hero]'));
  var readDays = Array.prototype.slice.call(root.querySelectorAll('[data-aw-hd-day-read]'));
  var dates = heroDays.map(function (el) { return el.getAttribute('data-date'); }).filter(Boolean);
  var toggle = root.querySelector('[data-aw-hd-toggle]');
  var dateLine = root.querySelector('[data-aw-hd-date]');
  var wedgeDia = root.querySelector('[data-aw-hd-wedgedia]');
  var visitorToday = ymd(new Date());
  var state = 'hoy';

  function pick(target) {
    if (!dates.length) return null;
    if (dates.indexOf(target) !== -1) return target;
    var best = dates[0], bd = Math.abs(diffDays(dates[0], target));
    for (var i = 1; i < dates.length; i++) {
      var d = Math.abs(diffDays(dates[i], target));
      if (d < bd) { bd = d; best = dates[i]; }
    }
    return best;
  }

  function show(dateStr) {
    heroDays.forEach(function (el) { el.hidden = el.getAttribute('data-date') !== dateStr; });
    readDays.forEach(function (el) { el.hidden = el.getAttribute('data-date') !== dateStr; });
  }

  function render() {
    // hub (no per-day groups): just localise the date line to visitor's today
    if (!dates.length) {
      if (dateLine) dateLine.textContent = fmt(visitorToday);
      return;
    }
    var want = state === 'hoy' ? visitorToday : addDays(visitorToday, 1);
    var chosen = pick(want);
    show(chosen);
    if (dateLine) dateLine.textContent = fmt(chosen);
    if (wedgeDia) wedgeDia.textContent = state === 'hoy' ? 'hoy' : 'mañana';
    if (toggle) {
      Array.prototype.slice.call(toggle.querySelectorAll('button')).forEach(function (b) {
        var on = b.getAttribute('data-day') === (state === 'hoy' ? 'hoy' : 'manana');
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-day]') : null;
      if (!b) return;
      state = b.getAttribute('data-day') === 'manana' ? 'manana' : 'hoy';
      render();
    });
  }
  render();

  /* ── boletín spam gates (block submit only; no UX noise) ─────
     There are now two boletín forms per page (inline near the top + footer),
     so bind every one of them: querySelector would have left the inline form
     with no honeypot, no timing gate and no email stash for CAPI matching. */
  var forms = root.querySelectorAll('form.aw-hd-boletin__form');
  var loadedAt = Date.now();
  Array.prototype.forEach.call(forms, function (form) {
    // Real-interaction flag. The old gate blocked any submit within 3s of page
    // load, which was safe while the form sat at 78-91% depth (nobody scrolls
    // that far that fast). The inline form sits at 17-27%, where a visitor
    // using email autofill can legitimately submit in ~2s and would have been
    // silently blocked — tap, nothing happens, no feedback. Requiring a genuine
    // interaction is a better bot signal than wall-clock anyway.
    var touched = false;
    ['focusin', 'input', 'keydown', 'pointerdown'].forEach(function (evt) {
      form.addEventListener(evt, function () { touched = true; }, { once: true, passive: true });
    });
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('.aw-hd-hp');
      if (hp && hp.value) { e.preventDefault(); return; }         // honeypot filled → bot
      if (!touched) { e.preventDefault(); return; }               // never touched → scripted submit
      if (Date.now() - loadedAt < 800) { e.preventDefault(); return; } // backstop floor
      // legit submit → suppress the 15% Klaviyo popup for this visitor (read in theme.liquid)
      try { localStorage.setItem('kl_horoscopo_optin', '1'); } catch (e2) {}
      // stash the email so the success block (after native reload) can send a
      // CAPI Lead with hashed email match — read + cleared there, never to GA4.
      try {
        var emailInput = form.querySelector('input[type="email"]');
        if (emailInput && emailInput.value) sessionStorage.setItem('aw_lead_email', emailInput.value);
      } catch (e3) {}
    });
  });
})();
